/**
 * tms请求api接口封装
 *
 *
 */
 import resetApi from './axios-promise';
(function(win, lib) {
    // 登录状态
    function handleResponse(opts, data) {
        if (data.success) {
            opts.success && opts.success(data);
        } else {
            if (data.error && data.error.code == 401) {
                alert('登陆失效，请重新登陆');
                lib.login && lib.login.goLogin();
            } else {
                opts.error && opts.error(data);
            }
        }
    }

    /**
   * ajax 请求
   * @param opts
   * @param ajaxType
   */
    function func_ajax(opts, ajaxType) {
    // 支持mock数据
        if (opts.mock) {
            var mockData = opts.mock;

            $.getJSON(mockData.path, function(data) {
                if (mockData.error) {
                    opts.error && opts.error(data);
                } else {
                    opts.success && opts.success(data);
                }
                opts.complete && opts.complete();
            });
            return;
        }

        var data = $.extend(true, {}, opts.data);
        data.format = 'json';
        let url = '';
        if (/^(\w+:\/\/)/.test(opts.api)) {
            url = opts.api;
        } else {
            url = process.env.__TMSAPI_HOSTURL__ + opts.api;
        }

        let libApiData = {
          url: url,
          type: ajaxType,
          data: data,
          dataType: 'json',
          contentType: 'application/x-www-form-urlencoded; charset=utf-8',
          success: function(data) {
            //状态码处理
            handleResponse(opts, data);
          },
          error: function(xhr, errorType, error) {
            opts.error && opts.error(xhr, errorType, error);
          },
          complete: function(xhr, status) {
            opts.complete && opts.complete(xhr, status);
          },
        }
        if(lib.cookie.get('yytools_token')){
          libApiData.headers = {
            authorization : lib.cookie.get('yytools_token')
          }
        }
        $.ajax(libApiData);
    }

    // export
    lib.tmsapi = {
        get: function(opts) {
            func_ajax(opts, 'GET');
        },
        post: function(opts) {
            func_ajax(opts, 'POST');
        },
    };
    lib.tmsapi.get = resetApi(lib.tmsapi.get.bind(lib.tmsapi));
    lib.tmsapi.post = resetApi(lib.tmsapi.post.bind(lib.tmsapi));
})(window, window['lib'] || (window['lib'] = {}));
